import config from "../config/config";
const isDev = typeof window !== 'undefined' && window.location.search.includes('isDev=1');
__webpack_public_path__ = process.env.NODE_ENV !== 'production'
	? config.publicPath
	: isDev
		? '/vendor/manage-products/dc-assets/'
		: `${config.staticDomains[0]}${config.publicPath}`;
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from 'react-router-dom';
import { loadableReady } from "@loadable/component";
import { Provider } from "react-redux";
import App from "./App";
import createStore from "../store/createStore";
import "./common/common.scss";
import "../font/justdial-b2b/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "../../src/font/gilroy/style.css";
import "../../src/font/Figtree/style.css";
import { createMemoryHistory } from 'history';
import NotchHandle from 'jd-library/NotchHandle';
import ErrorBoundary from "./ErrorBoundary";

// Global Browser Error Tracker
if (typeof window !== 'undefined') {
	window.onerror = (message, source, lineno, colno, error) => {
		fetch('/api/client-error', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				message,
				url: window.location.href,
				stack: error ? error.stack : `At ${source}:${lineno}:${colno}`
			})
		}).catch(() => {}); // Silent fail if server is unreachable
	};
}

const state = window.PRELOADED_STATE;
delete window.PRELOADED_STATE;
const store = createStore(state);
const history = createMemoryHistory();
const WrappedApp = (
	<Provider store={store}>
		<Router basename={state.session.basePath}>
			<ErrorBoundary>
				<App />
			</ErrorBoundary>
		</Router>
	</Provider>
);

loadableReady(() => {
	ReactDOM.hydrate(WrappedApp, document.querySelector("#root"));
});
